import { VehicleForm } from '@features/vehicles/components/VehicleForm';

export const VehicleStep = ({ form, onCirculationCityChange }) => {
  return (
    <VehicleForm form={form} onCirculationCityChange={onCirculationCityChange} />
  );
};